import { FC } from 'react';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { ActionModal, ModalTypes } from '@monorepo/controlled/src/components/modal/modals/action-modal/action-modal';
import { IAdminxStore } from '../../stores';
import { getCacheDataPreview } from '../../utils/bidder-domains-states.utils';
import styles from './cache-data-cell.module.scss';

interface CacheDataCellProps {
	cacheData: string;
	domain?: string;
}

export const CacheDataCell: FC<CacheDataCellProps> = ({ cacheData, domain }) => {
	const { modalsStore } = useStores<IAdminxStore>();
	const { preview, isTruncated } = getCacheDataPreview(cacheData);
	const displayText = isTruncated ? `${preview}...` : preview;

	const openModal = () => {
		modalsStore.addModal({
			children: (
				<ActionModal type={ModalTypes.Info} primaryBtnTitle="OK">
					<div className={styles.modalContent}>
						{domain ? <strong className={styles.domain}>{domain}</strong> : null}
						<div className={styles.fullText}>{cacheData}</div>
					</div>
				</ActionModal>
			),
		});
	};

	return (
		<div className={styles.cell}>
			<span className={styles.preview}>{displayText}</span>
			<a className={styles.iconLink} onClick={openModal} title="View full cache data">
				<Icon isMFP size="14px">
					expand-05
				</Icon>
			</a>
		</div>
	);
};
